/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "izolo",
        "0": "namhlanje",
        "1": "ngomso",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "day-narrow": {
        "-1": "izolo",
        "0": "namhlanje",
        "1": "ngomso",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "day-short": {
        "-1": "izolo",
        "0": "namhlanje",
        "1": "ngomso",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "month": {
        "-1": "inyanga ephelileyo",
        "0": "kule nyanga",
        "1": "kwinyanga ezayo",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "month-narrow": {
        "-1": "inya ephel.",
        "0": "kule nya.",
        "1": "kwinya eza.",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "month-short": {
        "-1": "inyanga ephel.",
        "0": "kule nya.",
        "1": "kwinyanga eza.",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "week": {
        "-1": "kwiveki ephelileyo",
        "0": "ku;e veki",
        "1": "kwiveki ezayo",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-narrow": {
        "-1": "veki ephel.",
        "0": "kule vek.",
        "1": "veki eza.",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-short": {
        "-1": "vek ephel.",
        "0": "kule vek.",
        "1": "vek eza.",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "year": {
        "-1": "unyaka ophelileyo",
        "0": "kulo nyaka",
        "1": "kunyaka ozayo",
        "future": {
          "other": "+{0} y"
        },
        "past": {
          "other": "-{0} y"
        }
      },
      "year-narrow": {
        "-1": "unyaka ophel.",
        "0": "kulo nyak.",
        "1": "unyak oza.",
        "future": {
          "other": "+{0} y"
        },
        "past": {
          "other": "-{0} y"
        }
      },
      "year-short": {
        "-1": "unyaka ophel.",
        "0": "kulo nyak.",
        "1": "kunyak oza.",
        "future": {
          "other": "+{0} y"
        },
        "past": {
          "other": "-{0} y"
        }
      }
    },
    "locale": "xh"
  });
}